export default __webpack_public_path__ + "static/media/Bracers of the Savage Fang.7045f2a0.jpg";